<template>
  <div>

    <v-navigation-drawer
      temporary
      app
      clipped
      ref="drawer"
      v-model="drawer"
      width="1500"
      touchless

      @transitionend="onTransitionend()"
    >
      <v-toolbar flat dark color="primary">
        <v-btn large icon @click="showDrawer(false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ this.title }}
        </v-toolbar-title>
        <div class="update_news" @click="onUpdateNews">
          <div>새로운 소식 보기</div>
        </div>
      </v-toolbar>

      <v-divider></v-divider>

      <drawer-menu
        :title="title"
        :name="name"
      >
      </drawer-menu>


    </v-navigation-drawer>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import {mapMutations} from 'vuex'
import DrawerMenu from '../components/DrawerMenu'

export default {
  components: {
    DrawerMenu
  },
  created() {
    this.showDrawer(true);
  },
  data() {
    return {
      menuData: {}
    }
  },
  props: {
    title: String,
    name: String,
    // menuData: Object,
  },
  computed: {
    ...mapFields([
      'drawer'
    ])
  },
  methods: {
    ...mapMutations([
      'showDrawer'
    ]),
    onTransitionend() {
      console.log('onTransitionend')
    },
    onUpdateNews() {
      if (this.name === 'realestate') {
        window.open('https://www.notion.so/dataknows/289fbf350ece4afb99f7d43b6a789fd2');
      } else if (this.name === 'economy') {
        window.open('https://www.notion.so/dataknows/245ffc25fe4646daa047d2485b979ccf')
      }
    }
  }
}
</script>

<style scoped>
.update_news {
  position: absolute;
  top: calc(25%);
  right: 15px;
  background-color: rgba(236, 50, 50, 0.8);
  padding: 3px 8px;
  border-radius: 2px;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.6);
}
.update_news:hover {
  cursor: pointer;
}
</style>
